/* eslint-disable jsx-a11y/no-static-element-interactions */
import { CommaArrayParam } from 'helpers/CommaArrayParam';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { useQueryParam, withDefault } from 'use-query-params';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';
import { useEffect, useState } from 'react';
import { STEPS_TITLE } from '../constants';
import { STEPS_TITLE_FOUR_STAGES } from '../constants_four_stages';
import styles from './styles';

const PcModelOptionsReviewStep = ({ step, expandedIndex, index }) => {
  const [showOptions, setShowOptions] = useState(true);
  // const [optionStep, setOptionStep] = useState(null);
  const { options, currentOptions } = usePcConfigurator();

  let UPDATED_STEPS_TITLE = STEPS_TITLE;
  const optionsFourStages = ['build', 'ultra-labs', 'accessories (new)'];
  let isInArray = false;
  let filteredOptions;

  if (options?.length != 0) {
    isInArray = optionsFourStages.includes(options[0].group_step_new);
    if (isInArray) {
      UPDATED_STEPS_TITLE = STEPS_TITLE_FOUR_STAGES;

      filteredOptions = currentOptions.filter(
        (option) => { 
          if (step == 'ultralabs') {
            return option.group_step_new === 'ultra-labs'
          } else if (step== 'accessoriesnew') {
            return option.group_step_new === 'accessories (new)'
          } else {
            return option.group_step_new === step
          }
        }
      )
    } else {
      UPDATED_STEPS_TITLE = STEPS_TITLE;

     filteredOptions = currentOptions.filter(
        (option) => option.group_step_new === step,
      );
    }
  }

  const [, setCurrentStep] = useQueryParam('step');
  const [completed, setCompleted] = useQueryParam(
    'completed',
    withDefault(CommaArrayParam, []),
  );

  const handleChangeClick = (option) => {
    setCurrentStep(option.group_step_new);
    setCompleted(completed.filter((item) => item !== option.group_type));
    setTimeout(() => {
      document
        .getElementById(`group-type-${option.group_type}`)
        .scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
    }, 500);
  };

  const toggleShowOptions = () => {
    setShowOptions(!showOptions);
  };

  useEffect(() => {
    if (expandedIndex === index) {
      setShowOptions(true);
    }
  }, []);

  return (
    <div className="pc-model-options-review-step">
      <div className="title" onClick={toggleShowOptions}>
        <div className="titleIcon">
          {showOptions ? (
            <Image draggable={false}
              src="/icons/ChevronUp.svg"
              alt="title-icon"
              width={24}
              height={24}
            />
          ) : (
            <Image draggable={false}
              src="/icons/ChevronDown.svg"
              alt="title-icon"
              width={24}
              height={24}
            />
          )}
        </div>

        {UPDATED_STEPS_TITLE[step]}
      </div>

      {showOptions && (
        <div>
          {filteredOptions.map((option) => (
            <div
              key={`${option.group_type}-${option.variant_id}`}
              className="group-container"
            >
              <div className="group">
                <div className="group-title">
                  <div className="group-title-text">{option.group_title}:</div>
                </div>
                <div className="group-option">
                  <span className="component-name">
                    {!option.title && <em>- None -</em>}
                    {option.title && option.title}
                  </span>

                  <button
                    className="action"
                    type="button"
                    onClick={() => handleChangeClick(option)}
                  >
                    Change
                  </button>
                </div>
              </div>

              <span className="component-name-mobile">
                {!option.title && <em>- None -</em>}
                {option.title && option.title}
              </span>
            </div>
          ))}
        </div>
      )}

      <style jsx>{styles}</style>
    </div>
  );
};

PcModelOptionsReviewStep.propTypes = {
  step: PropTypes.string.isRequired,
};

export default PcModelOptionsReviewStep;
